import { NotebookSidebarPreference, NotebookType } from '@mode/notebooks/contract';
import { createAction, props } from '@ngrx/store';

export const updatePreference = createAction('UpdatePreference', props<{ params: NotebookSidebarPreference }>());

export const updateNotebookType = createAction(
  '[Notebook] Patch',
  props<{ notebookToken: string; notebookType: NotebookType }>()
);
